import React, { useMemo } from 'react';
import { styled } from '@linaria/react';
import { clamp } from 'ramda';
import { InputText } from '@daedalus/atlas/InputText';
import { generatePriceInputDisplayValue, valueToValidNumberOrEmptyString } from './utils';
const {
  useState,
  useCallback,
  useEffect
} = React;
type PriceInputName = 'priceMin' | 'priceMax';
interface PropsType {
  value: number;
  currencySymbol: string | null | undefined;
  lowerBound: number;
  name: PriceInputName;
  upperBound: number;
  onChange: (name: string, value: number) => void;
}
const CurrencyWrapper = /*#__PURE__*/styled('span')({
  name: "CurrencyWrapper",
  class: "c1m6g2kj",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => InputText;
const CustomInputText = /*#__PURE__*/styled(_exp())({
  name: "CustomInputText",
  class: "c1q0n663",
  propsAsIs: true
});
export const PriceInput = ({
  value = 0,
  name,
  onChange,
  currencySymbol,
  upperBound,
  lowerBound
}: PropsType) => {
  const [inputValue, setInputValue] = useState<number>(value);
  const [useDisplayLogic, setUseDisplayLogic] = useState<boolean>(true);
  const [isInputFocused, setIsInputFocused] = useState<boolean>(false);
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  const toggleFocus = useCallback(() => setIsInputFocused(!isInputFocused), [isInputFocused]);
  const handleBlur = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    toggleFocus();
    const {
      name,
      value
    } = e.target;
    const validatedValue = clamp(lowerBound, upperBound, inputValue);
    setUseDisplayLogic(true);
    if (validatedValue !== Number(value)) {
      setInputValue(validatedValue);
    }
    onChange(name, validatedValue);
  }, [inputValue, lowerBound, onChange, upperBound, toggleFocus]);
  const handleChange = useCallback((value: string) => {
    const adjustedValue = valueToValidNumberOrEmptyString(value, inputValue);
    setUseDisplayLogic(false);
    setInputValue(adjustedValue ?? null);
  }, [inputValue]);
  const displayValue = useMemo(() => {
    const generatedPrice = generatePriceInputDisplayValue(inputValue, name, upperBound);
    if (useDisplayLogic && generatedPrice) {
      return generatedPrice;
    }
    return inputValue;
  }, [inputValue, name, upperBound, useDisplayLogic]);
  return <CustomInputText id="name" placeholder="" icon={<CurrencyWrapper translate="no">{currencySymbol}</CurrencyWrapper>} dataId={`PriceField-${name}`} name={name} size="lg" value={displayValue} onChange={handleChange} onBlur={handleBlur} onFocus={toggleFocus} />;
};

require("./PriceInput.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceInput.tsx");